import { environment } from '@environments/environment';
import { browserTracingIntegration, init } from '@sentry/angular';
import { defaultStackParser } from '@sentry/browser';
import { AppComponent } from '@app/app.component';
import { appConfig } from '@app/app.config';
import { bootstrapApplication, enableDebugTools } from '@angular/platform-browser';
import { installStateHistoryGuard } from '@state-routing/services/state-history-guard';
import { SplashScreen } from '@capacitor/splash-screen';

installStateHistoryGuard();

if (environment.useSentry) {
  init({
    dsn: 'https://94aa0825c3d54ebcb73bff73e1865b85@o4504055350689793.ingest.sentry.io/4504055353442306',
    integrations: [
      browserTracingIntegration(),
    ],
    tracePropagationTargets: ['localhost', 'https://dev.pyjam.com/api'],
    stackParser: defaultStackParser,
    tracesSampleRate: 1.0,
  });
}

function notifyAppReady(): void {
  if (typeof window === 'undefined') return;
  try {
    window.dispatchEvent(new Event('pyjam:app-ready'));
  } catch {
    // no-op
  }
}

bootstrapApplication(AppComponent, appConfig)
  .then(ref => {
    notifyAppReady();
    if (!environment.production) {
      const appComponent = ref.components[0];
      enableDebugTools(appComponent);
    }
  })
  .catch((err: unknown): void => {
    notifyAppReady();
    console.log(err);
    void SplashScreen.hide().catch((error: unknown): void => console.error('Splash screen hide failed', error));
  });

// const paypalClientId = environment.paypal.clientId;

// if (paypalClientId != null) {
//   addPaypalCardFields(paypalClientId);
// }

// function addPaypalCardFields(paypalClientId: string) {
//   if (typeof document === 'undefined') return;
//   const scriptDiv = document.createElement('script');
//   scriptDiv.src = `https://www.paypal.com/sdk/js?intent=authorize&client-id=${paypalClientId}&debug=true&currency=EUR&components=buttons,card-fields`;
//   document.getElementsByTagName('head')[0].insertAdjacentElement('afterbegin', scriptDiv);
// }
